import { render, staticRenderFns } from "./BaseSelectMultipleV2.vue?vue&type=template&id=2c8b8bbf&scoped=true&"
import script from "./BaseSelectMultipleV2.vue?vue&type=script&lang=js&"
export * from "./BaseSelectMultipleV2.vue?vue&type=script&lang=js&"
import style0 from "./BaseSelectMultipleV2.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BaseSelectMultipleV2.vue?vue&type=style&index=1&id=2c8b8bbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8b8bbf",
  null
  
)

export default component.exports